;(function () {
  'use strict'

  angular.module('pub.channels.service', []).factory('ChannelsService', ChannelsService)

  /** @ngInject */
  function ChannelsService($http, $q, API) {
    function list(t, start, limit, sort, filter) {
      var defered = $q.defer()

      let _sort = ''
      if (sort) {
        _sort = '&sort=' + sort
      }
      if (filter) {
        filter = '&onsale=' + filter
      } else {
        filter = ''
      }

      $http
        .get(
          API.API_URL +
            'publisher/channels?enrich=pct-sold,cnaus,cnaunss' +
            '&t=' +
            t +
            '&start=' +
            start +
            '&limit=' +
            limit +
            _sort +
            filter,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function get(sort) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/channels?sort=' + sort).success(defered.resolve)

      return defered.promise
    }

    function getCollectibles(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/channels/' + id + '/sets/collectibles')
        .success(defered.resolve)

      return defered.promise
    }

    function listSets(parentId) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/channels/' + parentId + '/sets').success(defered.resolve)

      return defered.promise
    }

    function listRelated(parentId, start, limit, sort) {
      var defered = $q.defer()

      $http
        .get(
          API.API_URL +
            'publisher/channels/' +
            parentId +
            '/sets/related?start=' +
            start +
            '&limit=' +
            limit +
            '&sort=' +
            sort,
        )
        .success(defered.resolve)

      return defered.promise
    }

    function listChannelFeatureBanners(parentId) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'channels/' + parentId + '/feature_banners').success(defered.resolve)

      return defered.promise
    }

    function listFeatureBanners() {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/banner_lists')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listRowTypes(start, limit) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/row_types?start=' + start + '&limit=' + limit + '&sort=id-desc')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function saveRelated(parentId, id, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + parentId + '/sets/' + id + '/related', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function deleteRelated(parentId, id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/channels/' + parentId + '/sets/' + id + '/related')
        .success(defered.resolve)

      return defered.promise
    }

    function getId(id) {
      var defered = $q.defer()

      $http.get(API.API_URL + 'publisher/channels/' + id).success(defered.resolve)

      return defered.promise
    }

    function save(model) {
      var defered = $q.defer()

      $http.post(API.API_URL + 'publisher/channels', model).success(defered.resolve)

      return defered.promise
    }

    function clone(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + id + '/clone')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function update(id, model) {
      var defered = $q.defer()

      $http.put(API.API_URL + 'publisher/channels/' + id, model).success(defered.resolve)

      return defered.promise
    }

    function remove(id) {
      var defered = $q.defer()

      $http.delete(API.API_URL + 'publisher/channels/' + id).success(defered.resolve)

      return defered.promise
    }

    function publish(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function unpublish(id) {
      var defered = $q.defer()

      $http.post(API.API_URL + 'publisher/channels/' + id + '/unpublish').success(defered.resolve)

      return defered.promise
    }

    function addRoy(parentId, id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + parentId + '/royalties/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function removeRoy(parentId, id) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/channels/' + parentId + '/royalties/' + id)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function saveLocales(channelId, rls) {
      var defered = $q.defer()
      var model
      if (rls === '') {
        model = { rl: '_' }
      } else {
        model = { rl: rls }
      }
      $http
        .post(API.API_URL + 'publisher/channels/' + channelId + '/locales', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function publishComingSoon(id) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + id + '/coming_soon')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function closeStore(id, body) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + id + '/close', body)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function listGenres() {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'publisher/genres')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function fixLeaderboards(id) {
      var defered = $q.defer()

      $http
        .get(API.API_URL + 'admin/channels/' + id + '/leaderboards/album/refresh')
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function reorder(channelId, order) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'publisher/channels/' + channelId + '/order/' + order)
        .success(defered.resolve)

      return defered.promise
    }

    function addYtLink(channelId, model) {
      var defered = $q.defer()

      $http
        .post(API.API_URL + 'publisher/channels/' + channelId + '/yt-links', model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function updateYtLink(channelId, linkId, model) {
      var defered = $q.defer()

      $http
        .put(API.API_URL + 'publisher/channels/' + channelId + '/yt-links/' + linkId, model)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    function deleteYtLink(channelId, linkId) {
      var defered = $q.defer()

      $http
        .delete(API.API_URL + 'publisher/channels/' + channelId + '/yt-links/' + linkId)
        .success(defered.resolve)
        .error(defered.reject)

      return defered.promise
    }

    return {
      list: list,
      get: get,
      getId: getId,
      getCollectibles: getCollectibles,
      save: save,
      clone: clone,
      update: update,
      remove: remove,
      publish: publish,
      unpublish: unpublish,
      listRelated: listRelated,
      saveRelated: saveRelated,
      deleteRelated: deleteRelated,
      listSets: listSets,
      addRoy: addRoy,
      removeRoy: removeRoy,
      saveLocales: saveLocales,
      listChannelFeatureBanners: listChannelFeatureBanners,
      listFeatureBanners: listFeatureBanners,
      listRowTypes: listRowTypes,
      publishComingSoon: publishComingSoon,
      listGenres,
      closeStore,
      fixLeaderboards,
      reorder: reorder,
      addYtLink: addYtLink,
      updateYtLink: updateYtLink,
      deleteYtLink: deleteYtLink,
    }
  }
})()
